import OrderDisplay, { type OrderDisplayProps } from './OrderDisplay';

export type { OrderDisplayProps };
export default OrderDisplay;
